import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import { useParams,Link } from "react-router-dom";

import Hero from "components/headers/light";
import Footer from "components/Footer";
import {Container} from "components/misc/Layouts";
import UserReviewInputAndList from "components/UserReviewInputAndList.js";
//redux
import {useAppSelector, useAppDispatch,loadNews} from "../../redux";

//hooks
import {useAuthUser} from '../../hooks'
import {SocialShareButton} from "components/SocialShareButton";

const Image = tw.img`w-170 mx-auto`;
const Text = tw.h3`lg:text-3xl text-xl leading-8 py-3 mx-auto font-semibold text-gray-900 `;
const Hr = tw.hr`mt-2`
const Heading = tw.text`text-2xl font-bold  text-gray-900`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl min-h-screen w-full mx-auto pt-20`;
const One = tw.div`max-w-screen-xl xsm:mt-12 `;
const Two = tw.div`mx-2`;
const DivComment = tw.div`py-5`;
const Root = tw.div`lg:flex lg:mt-0 xsm:-mt-8`;
const Div = tw.div`w-full px-5 xsm:py-2 lg:py-4 z-50 fixed bg-white`;

function NewsFullDetails({headingText}) {
  const {id} = useParams();
  const dispatch = useAppDispatch()
  const newsList = useAppSelector(state => state.news.news)
  const news = newsList.filter(item=>item.id === id)
  const login = useAuthUser()
  const [comment, setComment] = useState("");
  const [postedComments, setPostedComments] = useState([])

  

  useEffect(() => {
    if (news.length <= 0) {
     dispatch(loadNews())
   }
  }, [dispatch])
  
  const review_list = [
    {}
  ]
  return (
    <>
          <Div>
            <Hero />
        <Hr/>
          </Div>
      <Container>
        <ContentWithPaddingXl>
          <Heading>{headingText}</Heading>
          <Root>
            
            {news && news[0] &&
              <One>
                <Image src={news[0].cover_url} />
                <Two className="">
              <Text>{news[0].title}</Text>
                  <div dangerouslySetInnerHTML={{__html: news[0].content}} />
                </Two>
            </One>}  
          </Root>
          <SocialShareButton />
          <DivComment>
            <UserReviewInputAndList id={id}/>
          </DivComment>
          {/* <NewsFeed /> */}
        </ContentWithPaddingXl>
      </Container>
        
       
   
      <Footer /> 

    </>

  );
}

export default NewsFullDetails;